import { render } from "./FestivalPage.vue?vue&type=template&id=016dd574"
import script from "./FestivalPage.vue?vue&type=script&lang=js"
export * from "./FestivalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__